import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, message, Spin } from "antd";
import {
  getAuthenticatorDetailsAPI,
  setIsAuthAPI,
} from "../services/auth.service";
import { getUser } from "../appRedux/actions";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";

function GoogleAuthenticate(props) {
  const [data, setData] = useState({
    qr: "",
    loading: true,
  });
  const [loading, setLoading] = useState(false);
  const { authUser } = props;
  const navigate = useNavigate();
  
  async function handleClick() {
    try {
      setLoading(true);

      const response = await setIsAuthAPI(authUser.email);
      if (!response.success)
        throw new Error("Counld not update, please try again");

      message.success("User authenticated successfully");
      navigate("/verify-authenticator-code");
    } catch (error) {
      message.error(error.message || "Something went wrong, please try again");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let isMounted = true;

    async function getAuthenticatorDetails() {
      try {
        const response = await getAuthenticatorDetailsAPI({
          email: authUser.email,
          mode: "AUTHENTICATORAPP",
        });

        if (isMounted && response.success) {
          setData((prev) => ({ ...prev, qr: response.data }));
        } else if (isMounted) {
          throw new Error("Error getting the QR code, please try again");
        }
      } catch (error) {
        if (isMounted) {
          message.error(
            error.message || "Something went wrong, please try again"
          );
        }
      } finally {
        if (isMounted) {
          setData((prev) => ({ ...prev, loading: false }));
        }
      }
    }

    if (!authUser) {
      navigate("/signin");
    } else if (authUser.authenticated) {
      navigate("/");
    } else {
      getAuthenticatorDetails();
    }

    return () => {
      isMounted = false;
    };
  }, [authUser]);

  return (
    <section className="auth-layout-container">
      <div className="gx-app-login-wrap">
        <div className="verify-container">
          <div>
            <p className="authenticator-heading">
              Secure your Account with 2-Step Verification
            </p>
          </div>
          <div className="verify-container-block">
            <Spin spinning={data.loading}>
              <img className="authenticator-qr" alt="Authentication Qr" src={data.qr} />
            </Spin>

            <p style={{ textAlign: "center" }}>
              Scan the QR code below using your google authenticator app. This
              will generate a time-based verification code to enhance your account
              security. Then click "Next"
            </p>
          </div>
          <Button
            block type="primary"
            onClick={handleClick}
            loading={loading}
          >
            {"Next"}
          </Button>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = ({ auth }) => {
  return {
    authUser: auth.authUser || null,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getUser: bindActionCreators(getUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GoogleAuthenticate);
